if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.handleStorageTitleChange = this.updateStorageTitle.bind(this);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    connectedCallback() {
      this.productSection.addEventListener('on:variant:change', this.handleStorageTitleChange);
      // Wait for the deferred variant picker to finish initializing.
      setTimeout(() => {
        if (this.isConnected) this.updateStorageTitle();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.productSection.removeEventListener('on:variant:change', this.handleStorageTitleChange);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /** Updates only this panel's title with the selected storage. */
    updateStorageTitle(evt) {
      const picker = this.productSection.querySelector('variant-picker');
      const product = evt?.detail?.product || picker?.data?.product;
      if (!product) return;
      if (picker?.data?.product && String(product.id) !== String(picker.data.product.id)) return;

      const optionIndex = product.options.findIndex((option) => {
        const name = typeof option === 'string' ? option : option.name;
        return ['almacenamiento', 'storage'].includes(String(name).trim().toLowerCase());
      });
      if (optionIndex < 0) return;

      const selectedOptions = evt?.detail?.variant?.options || picker?.getSelectedOptions?.();
      const storage = selectedOptions?.[optionIndex];
      const heading = this.querySelector('.sticky-atc-panel__heading');
      if (!heading) return;

      const title = heading.querySelector('[data-storage-title]') || heading;
      title.textContent = storage ? `${product.title} ${storage}` : product.title;
    }

    /** Watches for a scroll to the bottom of the page. */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
